import { render, staticRenderFns } from "./MedalsList.vue?vue&type=template&id=69c90dd6&scoped=true&"
import script from "./MedalsList.vue?vue&type=script&lang=js&"
export * from "./MedalsList.vue?vue&type=script&lang=js&"
import style0 from "./MedalsList.vue?vue&type=style&index=0&id=69c90dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c90dd6",
  null
  
)

export default component.exports